import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scopeRadio", "panel", "entitySelect"]

  connect() {
    this.scopeChanged()
  }

  scopeChanged() {
    const selectedScope = this.selectedScope()

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("d-none", panel.dataset.scope !== selectedScope)
    })

    this.entitySelectTargets.forEach((select) => {
      const enabled = select.dataset.scope === selectedScope
      select.disabled = !enabled
    })
  }

  selectedScope() {
    const selected = this.scopeRadioTargets.find((radio) => radio.checked)
    return selected ? selected.value : "projects"
  }
}
